// There are a few places where the side2 is still handled in editor.js.erb
// and new_editor.js.erb, particularly with image handling.

import Cache from 'admin/editor/cache';
import { debounce } from 'lodash';
import Side2PlaceHolder from 'assets/images/side2_placeholder1.gif';
import PlaceHolderStripes from 'assets/images/placeholder_stripes.gif';

export default class Side2Element {
  constructor(options) {
    this.learnEditor = options.editor;
    this.savedText = null;
    this.activeElementId = null;
    this.activePosition = null;

    this.init();

    //clean up legacy side2 images
    $('.side-images ul').removeClass('thumbnails');
    $('.side-images ul li a').removeClass('thumbnail');


    $(document).on('mouseenter', '.build-side-wrapper li', function() {
      $('.side-image-options', this).css('visibility', 'visible');

    }).on('mouseleave', '.build-side-wrapper li', function() {
      $('.side-image-options', this).css('visibility', 'hidden');
    });
  }

  init() {
    const ua = navigator.userAgent,
      action = (ua.match(/iPad/i)) ? "touchstart" : "click";

    $(document).on('click', '.add-build-side', this.newElement.bind(this));
    $(document).on(action, '.submit-build-side', this.submitElement.bind(this));
    $(document).on(action, '.cancel-build-side', this.cancelElement.bind(this));
    $(document).on(action, '.delete-build-side', this.deleteElement.bind(this));
    $(document).on(action, '.split-build-side', this.splitElement.bind(this));
    $(document).on(action, '.build-side, .build-side a', this.editElement.bind(this));
    $(document).on(action, '.convert-image-side2-element', this.convertImageToSide2.bind(this));
    $(document).on(action, '.convert-crop-cancel', this.cancelCrop.bind(this));
    $(document).on(action, '.convert-pull-text', this.pullTextElement.bind(this));
    $(document).on('ajax:success', '.convert_asset', this.handleConvertImageCrop.bind(this));
    $(document).on(action, '.remove-asset', this.deleteImage.bind(this));
    $(document).on(action, '.license-build-side', this.updateImageLicense.bind(this));

    this.cache = new Cache('side2');
    this.image_upload_handler();
  }

  shouldShowButton() {
    return $('input[name="page_type"]').val() !== 'user';
  }

  addButtonTemplate() {
    return '<a class="add-build-side" href="#"><i class="fa fa-th-large"></i>Side&#178;</a>';
  }

  updateImageLicense(event) {
    event.preventDefault();

    var $img = $(event.target).parents('.medium-side, .small-side').find('a img')
    var that = this;
    var asset = parseInt($img.attr('class'), 10);
    var url =  '/pages/' + this.learnEditor.pageID + '/assets/' + asset + '/license';

    $.ajax({
      url: url,
      type: 'GET',
      dataType: 'html'
    }).done(function(data) {
      that.learnEditor.crop_image(data);
    });
  }

  newElement(event) {
    event.preventDefault();

    let link = $(event.currentTarget);

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    this.savedText = null;

    const cachedText = this.cache.get('text');

    this.insertSideBySide(link.closest('.button-bar, .bottom-button-bar'), cachedText);
    this.learnEditor.editing();
  }

  submitElement(event) {
    event.preventDefault();
    const $element = $(event.currentTarget).closest('.build-side-wrapper');
    const text = tinymce.activeEditor.getContent();

    //don't allow saving of the side-by-side row unless there is text and an image
    if (!text || no_image) {
      alert('Add text and image to save, or click cancel to exit.');
      return;
    }

    this.learnEditor.disable_text_editor($('.build-textarea'));
    const no_image = $element.find('.medium-placeholder').length;


    this.savedText = null;
    this.replaceSideBySide($element, text, this.activeElementId, this.activePosition);
    this.activeElementId = "";
    this.activePosition = "";

    this.learnEditor.save_page("Before Added Side-by-Side Element");
  }

  editElement(event) {
    event.preventDefault();
    //or if an editor is already present
    if(this.learnEditor.is_editor_enabled()) { //only one editor should be enabled at a time
      return;
    }

    let $element = $(event.currentTarget);

    if ($element.is('a')) {
      $element = $element.parents('.build-side');
    }

    const text = $('.side-text .text', $element).html();

    const cachedText = this.cache.get('text');

    //backup the text, save it in case of cancelling
    this.savedText = text;
    this.activeElementId = $element.closest('.build-side').attr('id');
    this.activePosition = $element.closest('.build-side').data('position');
    this.addEditor($element, cachedText || text);
    this.learnEditor.centerInView($('.build-side-wrapper'));
    this.learnEditor.editing();
  }

  cancelElement(event) {
    event.preventDefault();

    let $element = $(event.currentTarget);

    this.learnEditor.disable_text_editor($('.build-textarea'));
    //restore with global saved text
    this.replaceSideBySide($element.closest('.build-side-wrapper'), this.savedText, this.activeElementId, this.activePosition);
    this.activeElementId = "";
    this.activePosition = "";

    this.learnEditor.finishEditing();
    this.cache.delete();
  }

  deleteElement(event) {
    event.preventDefault();

    let $element = $(event.currentTarget);


    if (!confirm("Confirm deletion of this element.")) {
      return;
    }

    this.learnEditor.disable_text_editor($('.build-textarea'));

    this.activeElementId = "";
    this.activePosition = "";

    $element.parents('.build-side-wrapper').remove();
    this.learnEditor.save_page("Before Deleted  Side-by-Side Element");

    this.cache.delete();
  }

  splitElement(event) {
    event.preventDefault();

    let $element = $(event.currentTarget);


    if (!confirm("This will split the images and text of this elements into individual elements.  Are you sure you want to do this?")) {
      return;
    }

    this.learnEditor.disable_text_editor($('.build-textarea'));

    var elementId =
    this.learnEditor.editing();
    $.ajax({
      url: $('#editor-form').attr("action") + "/elements/" + this.activeElementId.split("-")[1] + "/split",
      type: 'PUT',
      contentType: 'application/json',
      data: JSON.stringify(this.learnEditor.formData("Before Split  Side-by-Side Element")),
      dataType: 'json'
    }).done(this.learnEditor.save_response.bind(this.learnEditor)).fail(this.learnEditor.save_response.bind(this.learnEditor));


    this.activeElementId = "";
    this.activePosition = "";

    this.cache.delete();
  }

  insertSideBySide($element, text) {
    const buildText = this.buildSideBySide(false, text);

    $element.hide();

    let $buildText = $(buildText).hide();

    $element.replaceWith($buildText);
    this.learnEditor.enable_text_editor($('#editor'));
    $('.build-side-wrapper').show();
    this.image_upload_side_first();

    this.watchState();
  }

  watchState($element) {
    var saveState = function(event) {
      var text = tinymce.activeEditor.getContent();
      this.cache.save({ text: text });
    }

    tinymce.activeEditor.on('keyup', debounce(saveState.bind(this), 500));
  }

  buildSideBySide(showPullTextOption = false, text) {
    text = text || "";
    text = text.replace(/'/g, "&#39;").trim();

    let buildText = [
      "<div class='build-side-wrapper'>",
        "<div colspan='2'>",
          "<div class='content'>",
            "<div class='side-images'>",
              "<ul class='image-placeholder'>",
                "<li class='fileinput-button side2-image-placeholder-first'>",
                  "<span>",
                    `<img class='medium-placeholder img-responsive' src='${Side2PlaceHolder}' alt=''>`,
                    "<input id='image-input' class='button' type='file' name='files'>",
                  "</span>",
                "</li>",
              "</ul>",
            "</div>",
            "<div class='side-text'>",
              "<div class='table-editor'>",
                `<textarea id='editor' class='build-textarea' style='display=block;'>${text}</textarea>`,
              "</div>",
            "</div>",
          "</div>",
          "<div class='editor-buttons'>",
            "<button class='delete-build-side delete'>Delete</button>",
            "<button class='cancel-build-side cancel'>Cancel</button>",
            "<button class='submit-build-side save'>Save</button>",
          "</div>",
        "</div>",
      "</div>"
      ].join('\n');

    let $buildText = $(buildText);

    if (showPullTextOption) {
      $buildText.find('.delete-build-side').after("<button class='convert-pull-text editor-button'>PULL BELOW TEXT</button>");
    }

    console.log("active element id")
    console.log(this.activeElementId)

    if (this.activeElementId) {
      $buildText.find('.delete-build-side').before("<button class='split-build-side destructive-option'>Split</button>");
    }

    return $buildText;
  }

  // saving a side-by-side element.
  // $element is typically the .build-side-wrapper, text is the text editor text
  replaceSideBySide($element, text, id, position) {
    //if there is no text (this includes saved text), just remove the element
    if (!text) {
      let $side = $element.parents('.build-side');
      $element.remove();

      if (!$side.has('.side-images, .side-text').length) {
        $side.remove();
      }

      return;
    }

    let buildElement =
      `<div id='${id || ''}' class='element side-element build-side' data-position='${position}'>
        <div class='side-images'>
          ${$element.find('.side-images').html()}
        </div>
        <div class='side-text'>
          <div class='text'>
            ${text}
          </div>
        </div>
      </div>`;

    let $buildRow = $(buildElement);

    $element.replaceWith($buildRow);

    let $smallSideImage = $buildRow.find('.small-side-image');

    if ($smallSideImage.length == 1) {
      $smallSideImage.parents('li').hide();
    } else {
      $smallSideImage.parents('li').css('display', 'inline');
    }

    $('.fileinput-button', $buildRow).remove();

    $('.side-image-options').remove();
  }

  //Takes the saved side-by-side row, and replaces it with the text editor, and
  //adds the image placeholder to allow editing
  //$element is a table row, text is the text from the editor
  addEditor($element, text, $imageElement = null, showPullTextOption = false) {
    let textIsNextElement = $element.nextAll(":not(.editor-button-line)").first().hasClass('build-text');

    let $buildText = $(this.buildSideBySide((showPullTextOption && textIsNextElement)));
    $buildText.find('.image-placeholder-first').remove();
    $buildText.find('textarea').val(text);

    let buildImage = [
      "<li class='image-placeholder fileinput-button side2-image-placeholder-additional'>",
        "<span>",
          "<button class='side2-upload-additional-image-button editor-button'><i class='fa fa-camera'></i>UPLOAD ANOTHER IMAGE</button>",
          "<input id='image-input-add' class='button' type='file' name='files'>",
        "</span>",
      "</li>"
    ].join('\n');

    //append editor and text
    if ($imageElement) {
      $('.side-images', $buildText).html($imageElement);
    } else {
      $('.side-images', $buildText).html($element.find('.side-images').html());
      $('.side-images ul', $buildText).append(buildImage);
    }

    $element.replaceWith($buildText);

    //show the hidden li. This is hidden when there is only one image for that table row.
    $('.small-side-image:first', $buildText).parents('li').hide();
    this.learnEditor.enable_text_editor($('#editor'));
    this.image_upload_side_additional();
    this.prepend_build_row_image_modifiers($('.build-side-wrapper'));
  }

  //side2 image modifiers
  prepend_build_row_image_modifiers($element) {
    var $medium_image = $element.find('.medium-side-image');
    var $small_images = $element.find('.small-side-image');
    var page_id = $('input[name$="page_id"]').val();

    var link = [
      '<div class="side-image-options">',
        '<div><a href="#" class="alt-build-image-side2">edit alt attribute</a></div>',
        '<div class="fileinput-button replace-button">replace<input class="replace-side-image" type="file" name="files"></div>',
        '<div><a href="#" class="license-build-side">license</a></div>',
        '<div><a href="#" class="remove-asset">remove</a></div>',
      '</div>'
    ];

    if ($medium_image) {
      // var id = parseInt($medium_image.attr("class"), 10);
      // link[5] = id;
      $medium_image.parents('li').prepend(link.join(''));
    }

    if ($small_images.length > 1) {
      $small_images.each(function(i, image) {
        if (i !== 0) {
          // var small_id = parseInt($(image).attr("class"), 10);

          // link[5] = small_id;
          $(image).parents('li').prepend(link.join(''));
        }
      });
    }

    this.replace_side_element_upload();
  }

  replace_side_element_upload() {
    $.cleanData('.replace-side-image');
    // this.dropzone_uploads();

    var that = this;
    $('.replace-side-image').fileupload({
      dataType: 'html',
      progressInterval: 20,
      bitrateInterval: 100,
      dropZone: null,
      add: function(e, data) {
        var url, asset, $container, page_id = $('input[name$="page_id"]').val();

        var $img = $(this).closest('li').find('img');
        asset = parseInt($img.attr('class'), 10);
        if ($img.hasClass('medium-side-image')) {
          url = '/pages/' + page_id + '/assets/' + asset + '/replace?update_type=first';
        } else {
          url = '/pages/' + page_id + '/assets/' + asset + '/replace?update_type=add';
        }
        data.url = url;

        data.submit();
      },
      done: function (e, data) {
        $('.bar').css("width", 0);
        $('.progress').addClass('fade');

        var result = $(data.result)[0];
        if ($(result).is('#cropModal')) {
          that.$replace_image_element = $(this);
          that.learnEditor.crop_image(data.result);
        } else {
          var $result = $(data.result);
          if ($result.children('li:first').hasClass('medium-side')) {
            //replacing the medium side image
            $(this).closest('ul').find('.medium-side-image-link:first').replaceWith($result.find('.medium-side-image-link'));
            $(this).closest('li').replaceWith($result.children('li:first'));

          } else {
            //replacing one of the smaller additional side2 images.
            $(this).closest('li').replaceWith($result.eq(0));
          }

          that.image_upload_side_additional();
        }
      }
    });
  }

  save_side_image_alt_attribute(assetId, altText, shouldSave=false) {
    let that = this;
    let assetUpdateUrl = `/pages/${this.pageID}/assets/${assetId}`
    let data = { 'asset': { 'alt_attribute': altText, 'update_type': 'alt_attribute' } };

    $.ajax({
      url: assetUpdateUrl,
      type: 'PUT',
      data: data,
      success: function(response) {
        if (shouldSave) {
          that.save_page("Before Add/Edit Image Alt Attribute");
        }
      },
      error: function(jqXHR, textStatus, errorThrown) {
        alert("Error saving alt attribute, please try again");
      }
    });
  }

  add_image_alt_attribute_side2($image) {
    let existingAltText = $image.attr('alt') || "";

    let altText = prompt("Enter the alt text for the image", existingAltText);
    if (altText == null || altText == "") {
      return;
    }

    let assetId = $image.attr('class').match(/\d+/g).join('');

    this.save_side_image_alt_attribute(assetId, altText);
  }

  image_upload_handler() {
    var that = this;

    //callback for when the 'crop' button is clicked in the crop image overlay.
    $(document).on('ajax:success', '.edit_asset', function(event, data, status, xhr) {
      var response = xhr.responseText;

      $('#cropModal').modal('hide');

      var $result = $(response);

      if (!$.trim(response) && (xhr.status === 200)) {
        //license type was updated for an image
        that.set_publish_text("License Set");
        return;
      }

      if ($(response).is('.table-image')) {
        $('.active-image-upload-container').html($result).removeClass('active-image-upload-container');

        that.prepend_table_image_modifiers();
      } else {
        //check if the image is being replaced, or if it's new.
        if ($result.children('li:first').hasClass('replace') || $result.eq(0).hasClass('replace')) {
          //check if the replaced image is a medium side2 or small...
          if ($result.children('li:first').hasClass('medium-side')) {
            //replacing the medium side image
            that.$replace_image_element.closest('ul').find('.medium-side-image-link:first').replaceWith($result.find('.medium-side-image-link'));
            that.$replace_image_element.closest('li').replaceWith($result.children('li:first'));
          } else {
            //replacing one of the smaller additional side2 images.
            that.$replace_image_element.closest('li').replaceWith($result.eq(0));
          }
          that.$replace_image_element = null;

          that.image_upload_side_additional();
        } else {
          //newly cropped side2 image.
          $(".image-placeholder").replaceWith(response);
          that.image_upload_side_additional();
        }
      }
    });

    //callback for when the crop image overlay cancel button is clicked
    $(document).on('click', '.cancel_overlay_asset', function(event) {
      event.preventDefault();

      if ($('#asset_update_type').val() !== 'license') { //don't delete if updating license
        $.ajax({
          type: "DELETE",
          url: $(this).attr('href')
        }).done(function( msg ) {
          $('#cropModal').modal('hide');
          $(".medium-placeholder").show();
          $(".build-image-placeholder").remove();
          $(".side2-upload-additional-image-button").show();
          $(".image-uploading").remove();
          this.enableEditor();
        });
      } else {
        $('#cropModal').modal('hide');
      }
    });
  }

  //for uploading the first side-by-side image
  image_upload_side_first() {
    var that = this;
    var page_id = $('input[name$="page_id"]').val();
    var post_url = '/pages/' + page_id + '/assets/side_first';
    $('#image-input').fileupload({
      dataType: 'html',
      url: post_url,
      progressInterval: 20,
      bitrateInterval: 100,
      add: function(e, data) {
        $(".medium-placeholder").hide();
        $(".medium-placeholder").after(that.imagePlaceholder);
        var $element = $(this).closest('img');
        data.submit();
      },
      done: function (e, data) {

        var result = $(data.result)[0];
        if ($(result).is('#cropModal')) {
          that.learnEditor.crop_image(data.result);
        } else {
          $(".image-uploading").remove();
          $(".image-placeholder").replaceWith(data.result);
          that.image_upload_side_additional();
        }
      }
    });
  }

  image_upload_side_additional() {
    var that = this;
    var page_id = $('input[name$="page_id"]').val();
    var post_url = '/pages/' + page_id + '/assets/side_add';
    $('#image-input-add').fileupload({
      dataType: 'html',
      url: post_url,
      progressInterval: 20,
      bitrateInterval: 100,
      add: function(e, data) {
        $(".side2-upload-additional-image-button").hide();
        $(".side2-upload-additional-image-button").after(that.imagePlaceholder);
        data.submit();
      },
      done: function (e, data) {
        var result = $(data.result)[0];
        if ($(result).is('#cropModal')) {
          that.learnEditor.crop_image(data.result);
        } else {
          $(".image-uploading").remove();
          $(".image-placeholder").replaceWith(data.result);
          that.image_upload_side_additional();
        }
      }
    });
  }

  build_image_placeholder() {
    return `<img src="${PlaceHolderStripes}" class="image-uploading img-responsive" />`
  }

  convertImageToSide2(event) {
    event.preventDefault();

    //or if an editor is already present
    if(this.learnEditor.is_editor_enabled()) { //only one editor should be enabled at a time
      return;
    }

    if (!confirm("Confirm conversion of this image to side2. This is not reversible.")) {
      return;
    }

    this.$convertElement = $(event.currentTarget).closest(".build-image");
    let $image = this.$convertElement.find("img");
    const assetId = parseInt($image.prop('class'), 10);
    const pageId = $('input[name$="page_id"]').val();
    const url = `/pages/${pageId}/assets/${assetId}/side_build`;

    this.savedText = $('.side-text .text', this.$convertElement).html();

    this.activeElementId = this.$convertElement.attr('id');
    this.activePosition = this.$convertElement.data('position');

    $.post(url, function(data) {
      if ($(data).is('#cropModal')) {
        this.cropImage(data);
      } else {
        this.addEditor(this.$convertElement, this.savedText, $(data), true);
        this.learnEditor.centerInView($('.build-side-wrapper'));
        this.learnEditor.editing();
      }
    }.bind(this));
  }

  handleConvertImageCrop(event, data, status, xhr) {
    $('#cropModal').modal('hide');
    this.addEditor(this.$convertElement, this.savedText, $(data), true);
    this.learnEditor.centerInView($('.build-side-wrapper'));
    this.learnEditor.editing();
  }

  pullTextElement(event) {
    event.preventDefault();

    if (!confirm("Confirm you would like to copy and remove the text from the below element. This is not reversible.")) {
      return;
    }

    let $element = $(event.currentTarget).parents('.build-side-wrapper');
    let $nextTextElement = $element.nextAll(":not(.editor-button-line)").first();

    tinymce.activeEditor.setContent($nextTextElement.html());
    $nextTextElement.remove();
    $(event.currentTarget).hide();
  }

  deleteImage(event, data, status, xhr) {
    let $link = $(event.currentTarget);
    //This is called when the delete is clicked on the side-by-side image, any of them
    //it's far too complex and will get refactored.
    //rafactored, made it more bonkers

    //determine if the image deleted was the medium image (the larger in the side-by-side)
    let is_medium = $link.closest('li').find('img').hasClass('medium-side-image');

    if (is_medium) {
      //remove the small image li that was deleted.
      $link.closest('li').next().remove();
      //get the next image, which is the next li img
      let $medium_image = $link.closest('li');
      let $next_img = $link.closest('li').next().find('.small-side-image');

      if ($next_img.length > 0) {
        let src = $next_img.attr('src');
        let medium_link = src.replace(/\/thumb\//, "/medium/");
        let large_link = src.replace(/\/thumb\//, "/large/");
        let asset_id_class = $next_img[0].className.split(" ").find(el => el.includes('-asset'));

        //set the next small images src to the medium and large links
        $medium_image.attr('href', large_link);
        $medium_image.find('img').attr('src', medium_link);
        // the moves the id so that the image is associated correctly on save
        $medium_image.find('img').removeClass($medium_image.find('img')[0].className.split(" ").find(el => el.includes('-asset')));
        $medium_image.find('img').addClass(asset_id_class);

        $next_img.hide();
      } else {
        //replace destroy asset with li with file input
        $link.parents('ul').addClass('image-placeholder');
        $link.closest('li').next().remove();
        $link.closest('li').replaceWith(this.mediumFileInput());
        this.image_upload_side_first();
      }
    } else {
      //deleting small secondary iamge
      $link.closest('li').remove()
    }
  }

  cropImage(result) {
    $("#page-editor").after(result);
    $('#cropModal').modal('show');
  }

  cancelCrop(event) {
    event.preventDefault();
    $('#cropModal').modal('hide');
  }

  // when deleting a side-by-side image, and there is only one image, re-add the original placeholder
  // to allow uploading again
  mediumFileInput() {
    return [
      "<li class='fileinput-button side2-image-placeholder-first'>",
        "<span>",
          `<img class='medium-placeholder img-responsive' src='${Side2PlaceHolder}' alt=''>`,
          "<input id='image-input' class='button' type='file' name='files'>",
        "</span>",
      "</li>"
    ].join('');
  }

  additionalFileInput() {
    return [
      "<li class='image-placeholder fileinput-button side2-image-placeholder-additional'>",
        "<span>",
          "<button class='side2-upload-additional-image-button editor-button'><i class='fa fa-camera'></i>UPLOAD ANOTHER IMAGE</button>",
          "<input id='image-input-add' class='button' name='files' type='file'>",
        "</span>",
      "</li>"
    ].join('');
  }
}
